import { uniqBy } from 'lodash';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const formatStatements = (data) => {
  const byYearStatements = data.reduce((acc, { year, month, id, account }) => {
    const statements = {
      id,
      month,
      last4Digits: account?.last4Digits,
      unitAccountId: account?.id
    };
    return {
      ...acc,
      [year]: uniqBy([...(acc[year] || []), statements], 'id')
    };
  }, {});

  const years = Object.keys(byYearStatements).sort((a, b) => b - a);
  const yearStatements = years.map((year) => {
    const statements = byYearStatements[year].sort(
      (a, b) => months.indexOf(b.month) - months.indexOf(a.month)
    );
    return { year, statements };
  });

  return yearStatements;
};

export const convertMonthToNumber = (month) => {
  const index = months.findIndex((item) => item?.toLowerCase() === month?.toLowerCase());
  return `0${index + 1}`.slice(-2);
};
